import { Component } from 'react';
import NavigationTabLinks from '../containers/navigationTabLinks';
import { WebCache } from '../../services/WebCache';

class NavigationTabLinksForCalendar extends Component {
    render() {
        const items = [
            { to: '/conciliation/calendar', icon: 'fe fe-search', label: `pages.calendar.title`},
            { to: '/conciliation/settlementVouchers', icon: 'fe fe-calendar', label: `pages.calendar.vouchers` },
            ...((WebCache.isUserARG() && WebCache.isAdvancedAllowed()) ? [
                { to: '/advanced/search', icon: 'fe fe-calendar', label: `pages.calendar.advanced` },
                { to: '/advanced/historic', icon: 'fe fe-calendar', label: `pages.calendar.historic` },
            ] : []),
        ];
        return (
            <NavigationTabLinks items={items}></NavigationTabLinks>
        )
    };
}

export default NavigationTabLinksForCalendar;
